/* tslint:disable */
/* eslint-disable */
export enum WorkConnectorKeyEnum {
  Ninox = 'ninox',
  Bexio = 'bexio',
  Clockodo = 'clockodo',
  Craftnote = 'craftnote',
  Eturnity = 'eturnity',
  Abacus = 'abacus',
  Of = 'of'
}
